<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Information Security Management"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Information <br class="d-none d-md-block">
                        Security Management
                    </h2>
                    <p>
                        고객의 데이터를 안전하게 보호하기 위해 전 직원 문서 보안 프로그램을 사용하고 있으며, <br class="d-none d-md-block">
                        ISO 27001 : 2013 정보보호 관리체계 인증 획득 및 보안관리 절차를 적용하여 데이터 및 시스템 자산을 보호 중
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="문서 중앙화">
                    <v-img src="/images/sub/wwd/information/info-img1.png" max-width="950" class="mx-auto"></v-img>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="보안 문서 등급화 ">
                    <p class="page-text dot-txt color-grey-2c mb-8 mb-lg-14">
                        폴더별 보안 <strong class="font-weight-bold color-point">등급 부여</strong> 하여 운영중
                    </p>
                    <div class="w-100 border pa-20 pa-md-30 pt-lg-38 pb-lg-60 mb-18 mb-lg-34">
                        <v-img src="/images/sub/wwd/information/info-img2.png" max-width="709" class="mx-auto"></v-img>
                    </div>
                    <p class="page-text dot-txt color-grey-2c mb-8 mb-lg-14">
                        정보자산 중요도
                    </p>
                    <table class="client-table w-100">
                        <colgroup>
                            <col style="width: 20%">
                            <col style="width: 11%">
                            <col style="width: 11%">
                            <col style="width: 11%">
                            <col style="width: 47%">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>
                                    <div class="table-inner">구분</div>
                                </th>
                                <th>
                                    <div class="table-inner">보안 레벨</div>
                                </th>
                                <th>
                                    <div class="table-inner">value</div>
                                </th>
                                <th>
                                    <div class="table-inner">평가 값 범위</div>
                                </th>
                                <th>
                                    <div class="table-inner">내용</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="3">
                                    <div class="table-inner">정보자산 중요도</div>
                                </th>
                                <td>
                                    <div class="table-inner">1</div>
                                </td>
                                <td>
                                    <div class="table-inner">1</div>
                                </td>
                                <td>
                                    <div class="table-inner color-point font-weight-bold">8~9점</div>
                                </td>
                                <td>
                                    <div class="table-inner left px-xl-40">비즈니스 수행에 필요한 핵심자산</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="table-inner">2</div>
                                </td>
                                <td>
                                    <div class="table-inner">2</div>
                                </td>
                                <td>
                                    <div class="table-inner color-point font-weight-bold">5~7점</div>
                                </td>
                                <td>
                                    <div class="table-inner left px-xl-40">비즈니스 수행에 영향을 주는 주요자산</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="table-inner">3</div>
                                </td>
                                <td>
                                    <div class="table-inner">3</div>
                                </td>
                                <td>
                                    <div class="table-inner color-point font-weight-bold">3~4점</div>
                                </td>
                                <td>
                                    <div class="table-inner left px-xl-40">핵심자산과 주요자산을 지원하는 일반자산</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="보안 프로그램 적용된 PC">
                    <v-row class="my-n10 my-lg-n40">

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon1.png"
                        iconWidth="48">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                파일 반출 전송 결제 시스템으로 결재된 파일에 한해 내외부 협업 지원
                            </p>
                            <p class="dot-txt sm grey-2c">
                                사용자 PC에 문서를 남기지 않아 랜섬웨어 감염을 미연에 방지
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon2.png"
                        iconWidth="50">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                외장하드, USB, CD, 화면캡쳐,프린트 제어, 공유폴더 제어,
                                첨부파일 제어, 복사/붙여넣기 차단, 원격프로그램 접속 제어
                            </p>
                            <p class="dot-txt sm grey-2c">
                                IP 정책을 통한 내/외부 파일 접근 제어
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon3.png"
                        iconWidth="48">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                파일 반출 전송 결제 시스템으로 결재된 파일에 한해 내외부 협업 지원
                            </p>
                            <p class="dot-txt sm grey-2c">
                                1단계 결재, 사전/사후 결재, 다단계, 참조 등 결재라인 저장
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon4.png"
                        iconWidth="50">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                중앙서버 스토리지 내 파일 암호화, 개인정보 암호화를 통한 기업 <br class="d-none d-lg-block">
                                문서자산 보호
                            </p>
                            <p class="dot-txt sm grey-2c">
                                실시간 백신 검사를 통한 바이러스 치료 및 제거
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon5.png"
                        iconWidth="54">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                별도 로컬 내 영역을 지정하여 대용량 파일 저장 및 속도 이슈 방지
                            </p>
                            <p class="dot-txt sm grey-2c">
                                보안드라이브 영역 내 파일 백업 및 용량 설정 지원
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/information/info-icon6.png"
                        iconWidth="52">
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                제목, 본문 내 삽입된 개인정보 및 기업 정책에 의해 설정된 특정 <br class="d-none d-lg-block">
                                보안 키워드 검출
                            </p>
                            <p class="dot-txt sm grey-2c mb-4 mb-lg-12">
                                검출 시 해당 문서를 격리 보관하여 외부로의 유출 차단, <br class="d-none d-lg-block">
                                파일 격리 알람 기능
                            </p>
                            <p class="dot-txt sm grey-2c">
                                개인정보보호 컴플라이언스에 대응가능
                            </p>
                        </sub-icon-box>

                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubIconBox from "@/components/client/ko/sub/sub-icon-box.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubIconBox,
    },
};
</script>

<style lang="scss" scoped>
</style>